$( document ).on("turbo:load", function () {
    if ($('#custom_form_preview_modal').length > 0) {
        $('.custom-form-preview-link').on('click', function () {
            var id = $(this).data('id');
            $('.main-custom-form').empty();
            $.ajax(
                {
                    url: window.location.href + '/' + id + '/preview',
                    success: function (data) {
                        $('.main-custom-form').html(data.form);
                        $('#preview-form').validate({
                            errorPlacement: function (error, element) {
                                addErrorLabelToElement(error, element);
                            }
                        });
                        bindSubmitToPreviewForm();
                        bindClickToSubmitButton();
                        checkboxLikeRadioBehavior();
                    }
                }
            );
        });

    }
    setGlyphToggle('validations', 'glyph');
    setGlyphToggle('settings', 'settings_glyph');
    setGlyphToggle('options', 'options_glyph');
    $('.custom-form-submit').on('click', function () {
        $('.custom-form-form').submit();
    });
});

function setGlyphToggle(divId, glyphId) {
    if ($('#' + divId).length > 0) {
        $('#' + divId).on('show.bs.collapse', function () {
            $('#' + glyphId).toggleClass('glyphicon-chevron-down');
        });
        $('#' + divId).on('hidden.bs.collapse', function () {
            $('#' + glyphId).toggleClass('glyphicon-chevron-down');
        });
    }

}

function checkboxLikeRadioBehavior(){
    $('.radio-behavior').change(function () {
        var checked = $(this).is(':checked');
        $(".radio-behavior").prop('checked',false);
        if(checked) {
            $(this).prop('checked',true);
        }
    });
}

function addErrorLabelToElement(error, element) {
    error.addClass('error');
    if($(element).parent().hasClass('radio-group')){
        error.insertAfter($(element).parent().parent().children().last());
        return;
    }
    error.insertAfter(element);
}

function bindSubmitToPreviewForm() {
    $('#preview-form').submit(function (event) {
        event.preventDefault();
        if($('#preview-form').valid()){
            $(this).html('Thank you. Answers have been submitted.');
        }
    });
}

function bindClickToSubmitButton() {
    $('#submit-preview-button').on('click', function () {
        $('#preview-form').submit();
    });
}
